import { createApp } from 'vue';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import store from '@/store';
import router from '@/router';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueApexCharts from 'vue3-apexcharts';
import AsyncComputed from 'vue-async-computed';
import { installDarkModeHelper } from '@/helpers/vuetifyTheme';
import MasonryStub from '@/stubs/masonry';
import WorkflowActionNode from '@/components/workflow/WorkflowActionNode';
import WorkflowActionInfoNode from '@/components/workflow/WorkflowActionInfoNode';
import WorkflowActionBlock from '@/components/workflow/WorkflowActionBlock';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import '@mdi/font/css/materialdesignicons.min.css';
import '@/assets/style.css';
import '@/assets/vuetify2-compat.css';

/**
 * Vue 3 app entry (vue3-migration).
 * Flowy removed from boot — canvas uses Vue Flow (Slice 3).
 */

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
app.use(VueAxios, axios);
app.use(VueApexCharts);
app.use(AsyncComputed);
installDarkModeHelper(app);

app.component('apexchart', VueApexCharts);
app.component('masonry', MasonryStub);
app.component('WorkflowActionNode', WorkflowActionNode);
app.component('WorkflowActionInfoNode', WorkflowActionInfoNode);
app.component('WorkflowActionBlock', WorkflowActionBlock);

const requireComponent = require.context(
  '@/components/base',
  true,
  /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );
  app.component(componentName, componentConfig.default || componentConfig);
});

if (process.env.NODE_ENV === 'development') {
  app.config.performance = true;
}

app.mount('#app');
